import React from "react";
export function extractIconSize(_ref) {
  var _React$Children$toArr, _React$Children$toArr2;

  let {
    icon
  } = _ref;
  return ((_React$Children$toArr = React.Children.toArray(icon)[0]) === null || _React$Children$toArr === void 0 ? void 0 : (_React$Children$toArr2 = _React$Children$toArr.props) === null || _React$Children$toArr2 === void 0 ? void 0 : _React$Children$toArr2.size) || "medium";
}